
const digest = 'b873b6afbaf07a13ba7be1153326f6335629fb65f96cfbe9bc88ed6747adcbcd';
const classes = {"wrapper":"_wrapper_180aa_1","date":"_date_180aa_5","item":"_item_180aa_14","content":"_content_180aa_22","medicament":"_medicament_180aa_31","title":"_title_180aa_36","moreInfo":"_moreInfo_180aa_43","moreInfoItem":"_moreInfoItem_180aa_50","text":"_text_180aa_59","controls":"_controls_180aa_62","link":"_link_180aa_73"};
const css = `._wrapper_180aa_1 {
  display: flex;
  flex-direction: column;
}
._wrapper_180aa_1 ._date_180aa_5 {
  font-weight: 600;
  font-size: 14px;
  padding: 18px 24px;
  border: 1px solid #eaedf3;
  border-top: 0;
  background: #f9fdff;
  color: #000000;
}
._wrapper_180aa_1 ._item_180aa_14 {
  display: flex;
  flex-direction: row;
  width: 100%;
  border: 1px solid #eaedf3;
  border-top: 0;
  background: #ffffff;
}
._wrapper_180aa_1 ._item_180aa_14 ._content_180aa_22 {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-size: 16px;
  color: #000000;
  padding: 24px;
}
._wrapper_180aa_1 ._item_180aa_14 ._content_180aa_22 ._medicament_180aa_31 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
._wrapper_180aa_1 ._item_180aa_14 ._content_180aa_22 ._medicament_180aa_31 ._title_180aa_36 {
  font-weight: 500;
  min-width: 255px;
}
._wrapper_180aa_1 ._item_180aa_14 ._content_180aa_22 ._medicament_180aa_31 ._title_180aa_36 span {
  font-weight: 400;
}
._wrapper_180aa_1 ._item_180aa_14 ._content_180aa_22 ._moreInfo_180aa_43 {
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}
._wrapper_180aa_1 ._item_180aa_14 ._content_180aa_22 ._moreInfo_180aa_43 ._moreInfoItem_180aa_50 {
  display: flex;
  flex-direction: row;
  gap: 5px;
  font-size: 14px;
}
._wrapper_180aa_1 ._item_180aa_14 ._content_180aa_22 ._moreInfo_180aa_43 ._moreInfoItem_180aa_50 ._title_180aa_36 {
  color: grey;
}
._wrapper_180aa_1 ._item_180aa_14 ._content_180aa_22 ._moreInfo_180aa_43 ._moreInfoItem_180aa_50 ._text_180aa_59 {
  color: #000000;
}
._wrapper_180aa_1 ._item_180aa_14 ._controls_180aa_62 {
  min-width: 200px;
  max-width: 200px;
  border-left: 1px solid #eaedf3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
  gap: 16px;
}
._wrapper_180aa_1 ._item_180aa_14 ._controls_180aa_62 ._link_180aa_73 {
  font-size: 14px;
  font-weight: 500;
  color: #1665d8;
  text-decoration: underline;
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  